import { ProductionEnvAlert } from "@dash/nav";
import { SearchButton } from "@dash/search";
import { GlobalSearchDialog } from "@megarax/home";
import { AppLinkTree } from "@megarax/links";
import { useContext } from "react";

import { IamAuthContext } from "@megaron/auth-react";

import { AccountHeader } from "../AccountHeader";
import { NavRecentDocuments } from "../history/NavRecentDocuments";
import { NavPinnedLinks } from "../pinned/NavPinnedLinks";
import { SignalsBellButton } from "../signals/SignalsBellButton";
import { NavDivider } from "./NavDivider";
import { NavLinkTreeSections } from "./NavLinkTreeSections";
import { NavSignOutButton } from "./NavSignOutButton";
import { useNavAccentColor } from "./useNavAccentColor";

type Props = {
  linkTree: AppLinkTree[];
  onSignOut: () => void;
  showProductionEnvAlert?: boolean;
  onNavigate: () => void;
};

export const MobileNavDrawerSheet: React.FC<Props> = ({ linkTree, onSignOut, showProductionEnvAlert, onNavigate }) => {
  const auth = useContext(IamAuthContext);
  const { accentColor, iconBackgroundColor } = useNavAccentColor(linkTree);

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        gap: "1.25rem",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        overscrollBehavior: "contain",
        minHeight: 0,
        flex: 1,
        height: "100%",
        padding: "0 1rem 1rem",
        paddingTop: "calc(1.25rem + env(safe-area-inset-top, 0px))",
      }}
    >
      <div css={{ display: "flex", flexDirection: "column", gap: "1.25rem", minHeight: "100%" }}>
        {auth.iamUser && (
          <div css={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <div css={{ flex: 1, minWidth: 0 }}>
              <AccountHeader
                name={`${auth.iamUser.firstName} ${auth.iamUser.lastName}`}
                groups={auth.iamUser.groups.map((group) => group.name)}
                profilePictureUrl={auth.iamUser.profilePictureUrl}
                hideSignOut
                color="black"
              />
            </div>
            <SignalsBellButton variant="pale" iconColor={accentColor} closeDrawer={onNavigate} />
          </div>
        )}

        <GlobalSearchDialog
          renderTrigger={(onOpen) => (
            <SearchButton
              onClick={onOpen}
              variant="pale"
              accentColor={accentColor}
              accentBackgroundColor={iconBackgroundColor}
            />
          )}
        />

        {showProductionEnvAlert && <ProductionEnvAlert />}

        <NavDivider />

        <NavPinnedLinks onNavigate={onNavigate} />

        <NavDivider />

        <NavRecentDocuments onNavigate={onNavigate} />

        <NavDivider />

        <NavLinkTreeSections linkTree={linkTree} onNavigate={onNavigate} />

        <div css={{ display: "flex", flexDirection: "column", gap: "1.25rem", marginTop: "auto", flexShrink: 0 }}>
          <NavDivider />
          <NavSignOutButton onSignOut={onSignOut} />
        </div>
      </div>
    </div>
  );
};
